import './styles.css';

export default function AssignmentInfo({ title, description, className }) {
  return (
    <div className={`assignment-info ${!description ? 'no-description' : ''} ${className}`}>
      <h5>{title}</h5>
      {
        description &&
          <p>{description}</p>
      }
    </div>
  );
}
